import React from "react";

/**
 * thread: flat array from GET /dpr/letters/<id>/, items shaped like:
 *   { type: 'comment', row_id, from, date, description, file }
 *   { type: 'reply', row_id, parent_comment_row_id, to, date, description, file }
 * onViewFile: (fileUrl, title, subtitle) => void
 */
export default function ThreadTimeline({ letter, thread, onViewFile }) {
  const comments = thread.filter((t) => t.type === "comment");
  const repliesFor = (commentRowId) =>
    thread.filter((t) => t.type === "reply" && t.parent_comment_row_id === commentRowId);

  const hasThread = thread.length > 0;

  if (!hasThread && !letter.file) {
    return <p className="thread-empty">No comments or replies on this letter yet.</p>;
  }

  return (
    <div className="thread-line">
      <ThreadItem
        item={{ type: "letter", label: "Original letter", date: letter.date, text: letter.description, file: letter.file }}
        onViewFile={onViewFile}
      />

      {comments.map((comment) => (
        <React.Fragment key={comment.row_id}>
          <ThreadItem
            item={{ type: "comment", label: comment.from || "Comment", date: comment.date, text: comment.description, file: comment.file }}
            onViewFile={onViewFile}
          />
          {repliesFor(comment.row_id).map((reply) => (
            <ThreadItem
              key={reply.row_id}
              item={{ type: "reply", label: reply.to || "Reply", date: reply.date, text: reply.description, file: reply.file }}
              isReply
              onViewFile={onViewFile}
            />
          ))}
        </React.Fragment>
      ))}
    </div>
  );
}

function ThreadItem({ item, isReply, onViewFile }) {
  return (
    <div className={`t-item ${item.type}${isReply ? " reply" : ""}`}>
      <div className="t-card">
        <div className="t-head">
          <span className={`t-type ${item.type}`}>{item.type}</span>
          <span className="t-date">{item.date}</span>
        </div>
        <div className="t-from">{item.label}</div>
        <p className="t-text">{item.text}</p>
        {item.file && (
          <button
            type="button"
            className="file-link"
            onClick={() => onViewFile(item.file, item.label, `${item.type} · ${item.date}`)}
          >
            📎 View file
          </button>
        )}
      </div>
    </div>
  );
}